import { useEvent, useState } from 'hooks'
import $ from 'jquery'
import { debounce } from 'utils'

import { getFormComponents } from './selector'

type State = {
	questionnaireSelect: HTMLSelectElement | null
}

export const Form = (() => {
	const { state, setState } = useState<State>()

	const initSelect = () => {
		const { questionnaireSelect } = state

		if (questionnaireSelect === null) {
			return
		}

		const urlString = questionnaireSelect.getAttribute('data-url')

		if (urlString === null) {
			return
		}

		const change = useEvent(questionnaireSelect, 'change')
		change.register(
			debounce(() => {
				// @ts-ignore
				$.nette.ajax({
					type: 'POST',
					url: urlString,
					data: {
						questionnaireId: questionnaireSelect.value,
					},
				})
			}),
		)
	}

	const init = () => {
		setState({ ...getFormComponents() })

		initSelect()
	}

	return {
		init,
	}
})()
